import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ApolloManager } from "./contexts/ApolloProvider";
import { AuthProvider } from "./contexts/AuthProvider";
import StoreProvider from "./contexts/StoreProvider";
import "normalize.css";
import "./index.scss";
import { routes } from "./routes";
import { adminRoutes } from "./adminRoutes";
import AppErrorBoundary from "./components/AppErrorBoundary";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import AdminRoute from "./components/AdminRoute";
import NoMatch from "./pages/NoMatch";
import Session from "./components/Session";
import Maintenance from "./components/Maintenance";
import AppWrapper from "./components/AppWrapper";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: window.location.hostname,
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: process.env.NODE_ENV !== "development",
    }),
  ],
});

const root = document.getElementById("root");

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={AppErrorBoundary} showDialog={false}>
    <Maintenance>
      <StoreProvider>
        <BrowserRouter>
          <ApolloManager>
            <AuthProvider>
              <AppWrapper>
                <Session>
                  <Switch>
                    <Route exact path="/login">
                      <Redirect to="/" />
                    </Route>
                    {routes.map(({ path, name, Component, authenticated }) => {
                      if (authenticated) {
                        return (
                          <AuthenticatedRoute
                            key={`${name.toLocaleLowerCase()}`}
                            exact
                            path={path}
                            component={Component}
                          />
                        );
                      }
                      return (
                        <Route
                          key={`${name.toLocaleLowerCase()}`}
                          exact
                          path={path}
                          component={Component}
                        />
                      );
                    })}
                    {adminRoutes.map(({ path, name, Component }) => (
                      <AdminRoute
                        key={`${name.toLocaleLowerCase()}`}
                        exact
                        path={path}
                        component={Component}
                      />
                    ))}
                    <Route path="*">
                      <NoMatch />
                    </Route>
                  </Switch>
                </Session>
              </AppWrapper>
            </AuthProvider>
          </ApolloManager>
        </BrowserRouter>
      </StoreProvider>
    </Maintenance>
  </Sentry.ErrorBoundary>,
  root
);
